import { useQuery } from '@tanstack/react-query';

import { fetchDirectClaimsApi } from './api';
import { DirectClaimsParams } from './DirectClaims.types';

/*
 * The report is read live from GlobeMed on every search, which can take a few
 * seconds, so a result is kept for a minute rather than refetched each time
 * the window regains focus.
 */
export default function useDirectClaimsQuery(params: DirectClaimsParams) {
  return useQuery(['healthClaims', 'direct', params], fetchDirectClaimsApi, {
    enabled: !!params.startDate,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
    retry: false,
  });
}
